export const theme = {
    colors: {
        primary: '#080d21', // Rich Black
        secondary: '#efefef', // Antiflash White
        accent: '#0a2c51', // Chocolate Cosmos
        textPrimary: '#080d21', // Rich Black
        textSecondary: '#08211e', // Dark Green
        darkGreen: '#08211e', // Dark Green
        black: '#070707', // Black
        error: '#531323', // Chocolate Cosmos (for error)
        cubeOne: '#c2dff9',
        cubeTwo: '#fd5454',
    },
    fonts: {
        main: 'Sedgwick Ave Display, cursive',
    },
    gradients: {
        top: 'linear-gradient(0deg, #efefef, #080d21, #08211e, #070707, #531323)',
        right: 'linear-gradient(90deg, #efefef, #080d21, #08211e, #070707, #531323)',
        bottom: 'linear-gradient(180deg, #efefef, #080d21, #08211e, #070707, #531323)',
        left: 'linear-gradient(270deg, #efefef, #080d21, #08211e, #070707, #531323)',
        topRight: 'linear-gradient(45deg, #efefef, #080d21, #08211e, #070707, #531323)',
        bottomRight: 'linear-gradient(135deg, #efefef, #080d21, #08211e, #070707, #531323)',
        topLeft: 'linear-gradient(225deg, #efefef, #080d21, #08211e, #070707, #531323)',
        bottomLeft: 'linear-gradient(315deg, #efefef, #080d21, #08211e, #070707, #531323)',
        radial: 'radial-gradient(#efefef, #080d21, #08211e, #070707, #531323)',
    },
    breakpoints: {
        mobile: '768px',
        tablet: '1024px',
    },
    responsive: {
        mobile: `
            @media (max-width: 768px) {
                body {
                    background-color: #070707; /* Black */
                }
                h1, p {
                    color: #efefef; /* Antiflash White */
                }
                button {
                    background-color: #08211e; /* Dark Green */
                }
                .error {
                    color: #531323; /* Chocolate Cosmos */
                }
            }
        `,
        tablet: `
            @media (max-width: 1024px) {
                body {
                    background-color: #08211e; /* Dark Green */
                }
                h1, p {
                    color: #efefef; /* Antiflash White */
                }
                button {
                    background-color: #080d21; /* Rich Black */
                }
                .error {
                    color: #531323; /* Chocolate Cosmos */
                }
            }
        `,
        desktop: `
            @media (min-width: 1025px) {
                body {
                    background-color: #efefef; /* Antiflash White */
                }
                h1, p {
                    color: #080d21; /* Rich Black */
                }
                button {
                    background-color: #531323; /* Chocolate Cosmos */
                }
                .error {
                    color: #531323; /* Chocolate Cosmos */
                }
            }
        `,
    },
};
